import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  menuId: 1,
};

const profileMenuSlice = createSlice({
  name: "productsearch",
  initialState,
  reducers: {
    setProfileMenuID: (state, action) => {
      state.menuId = action.payload;
    },
  },
});

export const { setProfileMenuID } = profileMenuSlice.actions;

export default profileMenuSlice.reducer;
